import { Unplug } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const UnplugIcon = createLucideIcon(Unplug);
